import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

interface dashboardContextInterface {
    setDashboardId: (arg0: string | null) => void;
    setDashboardName: (arg0: string | null) => void;
}

const ClearDashboardInfo: FC<PropsWithChildren> = ({ children }) => {
    const { setDashboardId, setDashboardName } = useOutletContext<dashboardContextInterface>();

    useEffect(() => {
        setDashboardName(null);
        setDashboardId(null);
    }, []);

    return <>{children}</>;
};

export default ClearDashboardInfo;
